function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "m89.2 21-9.3-9.3c-1.2-1.2-3.1-1.2-4.2 0l-40.5 40.4c-.2.2-.4.5-.6.8l-8.2 17.5c-.5 1.1-.3 2.5.6 3.4.6.6 1.3.9 2.1.9.4 0 .9-.1 1.3-.3l17.5-8.2c.3-.1.6-.3.8-.6l40.5-40.5c.6-.6.9-1.3.9-2.1s-.3-1.5-.9-2zm-44.4 40.1-9.5 4.5 4.5-9.5 28.9-28.9 5.1 5.1zm33.1-33.1-5.1-5.1 4.9-4.9 5.1 5.1z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "m80.8 45.2c-1.7 0-3 1.3-3 3v1.6 31.5h-59.2v-59.5h6.4 2.8 27.4c1.7 0 3-1.3 3-3s-1.3-3-3-3h-27.4-2.8-6.4c-3.3 0-6 2.7-6 6v59.5c0 3.3 2.7 6 6 6h59.2c3.3 0 6-2.7 6-6v-11.9-19.6-1.6c0-1.6-1.4-3-3-3z"
});

var SvgWrite = function SvgWrite(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    fill: "#000000",
    enableBackground: "new 0 0 100 100",
    viewBox: "0 0 100 100",
    x: "0px",
    y: "0px",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgWrite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/write.6f5a81ca.svg";
export { ForwardRef as ReactComponent };